import { Grid } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import UploadButton from '../journey/UploadButton';
import Theme from '../ui/Theme';
import Image from './Image';

const useStyles = makeStyles(() => ({
  textfield: {
    backgroundColor: Theme.palette.secondary.main,
    width: '345px',
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
  },
  btnUploadStyle: {
    height: '24px',
    width: '100%',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'center',
    letterSpacing: '0.2px',
    color: Theme.palette.quad.main,
  },
}));
const UploadField = (props) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" justifyContent="flex-end" className={classes.textfield}>
      <Grid item>
        <Image alt="" name={props.name} src={props.value} style={{ height: '26px' }} />
      </Grid>
      <Grid item>
        <UploadButton
          name={props.name}
          disableElevation
          handleImageUpload={props.handleChange}
          className={classes.btnUploadStyle}
        />
      </Grid>
    </Grid>
  );
};

export default UploadField;
